import KwaiLog  from '@kibt/weblogger/lib/log.browser';
import cookies from 'js-cookie';
// import KwaiLog  from '@kibt/weblogger';
import { isProduction, isTest } from './env';
import { userId } from './const';
import { getQuery } from './util';

let VUE_APP_LOG_TYPE = '';

if (isProduction) {
    VUE_APP_LOG_TYPE = 'oversea';
}

if (isTest) {
    VUE_APP_LOG_TYPE = 'test';
}

const radar = {
    // 雷达平台上的唯一标识
    projectId: 'cfb09b178a',
    // 上报采样率，1 为全部上报
    sampling: 1,
};

// WebLogger内核SDK配置参数
const logConfig = {
    env: VUE_APP_LOG_TYPE || 'development' as any,
    proto: 'v3',
    autoPV: false,
    fps: false,
    logger: !isProduction,
    radar,
};
const querys = getQuery();
const kpn = cookies.get('kpn') || querys?.kpn || 'KWAI';
const webCountry = cookies.get('web_country') || querys?.countryInfo;
// 公参配置
const baseOptions = {
    channel: cookies.get('c') || '',
    product_name: kpn,
    package_name: kpn,
    user_id: userId || querys?.userId || querys?.['share_uid'],
    h5_extra_attr: {
        county_name: {
            country:
                webCountry === 'br'
                    ? 'BRA'
                    : (webCountry || '').toUpperCase() || 'UNKNOWN',
            bucket: cookies.get('bucket') || 'UNKNOWN',
        },
    },
};
// refer: https://component.corp.kuaishou.com/docs/weblogger/views/docs/config.html
// export const webLogger = new Weblog(logConfig as any, baseOptions);

let kwailog = null as any;

export function getKwaiLog() {
    if (!kwailog) {
        kwailog = (new KwaiLog(logConfig, baseOptions)).weblog;
    }
    return kwailog;
}

// 接入kibilogger
// refer: https://docs.corp.kuaishou.com/k/home/VTEZRDemqihg/fcACO3M1wQVXJg3jP4i3ubXfh
// export const webLogger = new KwaiLog(logConfig as any, baseOptions).weblog;
// 日志类型
enum LogType {
    // 曝光
    show = 'SHOW',
    // 点击
    click = 'CLICK',
    // PV
    pv = 'PV',
    // 雷达事件
    custom = 'CUSTOM',
}

export interface LogData {
    type: keyof typeof LogType;
    name: string;
    value?: Record<string, any>;
    eventId?: string;
}

/**
 * 生成上报参数
 * @param data 上报数据
 * @returns PVOptions | ShowOptions | TaskOptions | CustomOptions
 */
const generateLogParams = (
    data: LogData
) => {
    // PV曝光其他参数暂时不支持
    if (data.type === 'pv') {
        return {
            type: 'enter',
            page: data.name,
            params: data.value,
            eventId: data.eventId,
        };
    }

    if (data.type === 'custom') {
        return {
            key: data.name,
            value: data.value,
            eventId: data.eventId,
        };
    }

    // click 和 show 事件
    return {
        action: data.name,
        params: data.value,
        eventId: data.eventId,
    };
};

/**
 * 数据上报
 * @param data 上报数据
 * @param immediate 是否立即上报
 */
const logCollect = (data: LogData, immediate?: boolean) => {
    const { type } = data;

    // 不存在类型则不上报
    if (!type) {
        return;
    }

    const logParams = generateLogParams(data);
    const logType = LogType[type];
    const webLogger = getKwaiLog();
    if (immediate) {
        webLogger.sendImmediately(logType, logParams as any);
    } else {
        webLogger.collect(logType, logParams as any);
    }
};

/**
 * 收集上报埋点
 * @param data
 */
export const sendLog = (data: LogData) => {
    logCollect(data);
};

/**
 * 立即上报埋点
 * @param data
 */
export const immediateSendLog = (data: LogData) => {
    logCollect(data, true);
};

interface RadarLogData {
    // 事件名（必填）
    name: string;
    // 事件类型（可选）
    event_type?: string;
    // 业务分类（可选）
    category?: string;
    // 事件相关源文件（可选）
    src?: string;
    // 事件结果（可选）
    result_type?: string;
    // 消息（可选）
    message?: string;
    // 额外信息（建议使用json string - 可选）
    extra_info?: string;
    // 时长，可以计算分位数，不涉及可以不传（可选）
    duration?: number;
}

/**
 * 雷达上报：自定义事件
 */
export const radarLog = (data: RadarLogData) => {
    const { duration } = data;
    try {
        const webLogger = getKwaiLog();
        if (webLogger?.plugins?.radar) {
            webLogger.plugins.radar.event(data, {
                duration,
            });
        }
    } catch (error) {
        console.error(error);
    }
};
